import React from 'react';
import styled from 'App/styled';
import { OTHER_CATEGORIES } from '@nykaa/seo/constants';

import { Categories as categoryType } from 'store/footer/types';
import { contentTypes, isToRenderContent } from '../helper';

const Wrapper = styled.div`
  margin-top: 20px;
`;

const Row = styled.div`
  margin-bottom: 20px;
  strong {
    text-transform: capitalize;
    ${({ theme }) => theme.typography.titleXSmall};
    margin: 16px 0 10px;
    color: ${(props) => props.theme.footerLinks};
  }

  li {
    margin-bottom: 0;
    padding-right: 4px;
    display: inline;
    line-height: 20px;

    a {
      text-transform: capitalize;
      color: ${(props) => props.theme.footerLinks};
      ${({ theme }) => theme.typography.bodyMedium};
      text-decoration: none;
    }
  }
`;

const isLast = (index: number, length: number) => index + 1 === length;

interface Props {
  title: string;
  categories: categoryType;
  pageType: string;
}

const CategoriesSection = ({ title, categories, pageType }: Props) => {
  if (!isToRenderContent(pageType, contentTypes.PriceList)) {
    return null;
  }

  return (
    <Wrapper>
      {categories &&
        Object.keys(categories).map((key) => {
          const showTitle =
            !!title && key.toLowerCase() !== OTHER_CATEGORIES.toLowerCase();
          return (
            <Row key={`cat_sect_${key}`}>
              <strong>{showTitle ? `${title} ${key}` : key}</strong>
              <ul>
                {categories[key] &&
                  categories[key].map((item, index) => {
                    const char = isLast(index, categories[key].length)
                      ? ''
                      : ',';
                    return (
                      <li key={`cat_sect_li${item?.name}`}>
                        <a href={item?.link}>{`${item?.name}${char}`}</a>
                      </li>
                    );
                  })}
              </ul>
            </Row>
          );
        })}
    </Wrapper>
  );
};

export default CategoriesSection;
